import React, {useCallback, useEffect, useRef, useState} from 'react'
import DemandOffersService from "services/DemandOffersService";
import {connect} from 'react-redux'
import Loading from "components/Loading";
import RouterPath from "libs/RouterPath";
import {PurchaserOfferContextProvider} from "context/PurchaserOfferContext";
import {OfferStageTranslationsContextProvider} from "context/OfferStageTranslationsContext";
import OfferEditPanel from "../../../../contractor/demand/scenes/offer/components/panels/offerEdit/OfferEditPanel";
import {StageSectionsUrlParams} from "../../../../contractor/demand/scenes/offer/constants/StageSections";
import {useParams} from "react-router";
import DemandOffersOfferService from "services/DemandOffersOfferService";
import {OfferMode} from "../../../../contractor/demand/scenes/offer/components/common/constants/OfferMode";
import {OfferSectionProvider} from "context/OfferSectionContext";
import InfoBar from "components/complex/infobar/InfoBar";
import StageBar from "components/complex/stagebar/StageBar";
import Page from "components/Page";
import {makeStyles} from "@material-ui/core";
import GridBlock from "../../../../../components/GridBlock";
import Button from "../../../../../components/Button";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import Tr from "../../../../../translations/Translations";

const useStyles = makeStyles(theme => ({
    content: {
        margin: theme.spacing(2),
        padding: theme.spacing(2),
        border: `solid 1px ${theme.palette.background.paper}`,
        borderRadius: theme.shape.borderRadius,
        backgroundColor: theme.palette.background.paper
    },
    button: {
        margin: theme.spacing(2),
    }
}));

function PurchaserOfferPanel(
    {
        match,
        demandHeader
    }) {
    const classes = useStyles();
    const params = useParams();
    const demandId = match.params.id;
    const stageId = match.params.stageId;
    const openedSectionParam = params.section;
    const [stageTranslations, setStageTranslations] = useState({});
    const panelRef = useRef();
    const [contextSection, setContextSection] = useState(null);


    useEffect(() => {
        if (stageId === undefined || openedSectionParam === undefined) {
            const href = RouterPath.createPath(RouterPath.purchaserDemand.PURCHASER_DEMAND_ID_PREVIEW_ID_STAGE_ID_SECTION, {
                id: demandId,
                stageId: 0,
                section: StageSectionsUrlParams.OFFER_EDIT
            });
            RouterPath.redirectWithoutHistory(href);
        }
        // eslint-disable-next-line
    }, [openedSectionParam, stageId])


    useEffect(() => {
        if (stageId !== undefined && openedSectionParam !== undefined) {
            DemandOffersService.getStageTranslations(demandId, stageId, 1).then(resp => setStageTranslations(resp));
            DemandOffersOfferService.getPreviewSection(demandId, stageId, 1, OfferMode.EDIT).then((resp) => setContextSection(resp))
        }
        return () => {
            DemandOffersService.clearResources(DemandOffersService.DEMAND_STAGE_SECTIONS_LIST);

        }
    }, [demandId, stageId, openedSectionParam])

    const getStageTranslation = useCallback((trKey) => {
        return stageTranslations[trKey] || trKey;
    }, [stageTranslations]);

    const backClick = () => {
        if(demandHeader.forceRedirectOldPlatform) {
            window.location.href = demandHeader.forceRedirectOldPlatform;
        } else {
            RouterPath.redirect(RouterPath.createPath(RouterPath.myProcedure.steps.MP_1_ID, {id: demandId}));
        }
    }

    return (
        <>
            {
                !contextSection ? <Loading/> :
                    <Page>
                        <InfoBar/>
                        <StageBar/>
                                        {
                                            <GridBlock justify="flex-end">
                                                <Button
                                                    onClick={backClick}
                                                    Icon={ArrowBackIosIcon}
                                                    variant={"outlined"}
                                                    className={classes.button}
                                                >{Tr("back_to_demand")}</Button>
                                            </GridBlock>
                                        }
                        <div className={classes.content}>
                            <PurchaserOfferContextProvider value={{contractorDepartmentId: 1, supplierId: 1, preview: true}}>
                                <OfferStageTranslationsContextProvider value={getStageTranslation}>
                                    <OfferSectionProvider value={contextSection}>

                                        <OfferEditPanel panelRef={panelRef} sectionId={contextSection.section}/>
                                    </OfferSectionProvider>
                                </OfferStageTranslationsContextProvider>
                            </PurchaserOfferContextProvider>
                        </div>
                    </Page>
            }
        </>
    )
}


export default connect((state) => ({
    demandHeader: state.resources.demandHeader
}), {})(PurchaserOfferPanel)